import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-data-home',
  templateUrl: './data-home.component.html',
  styleUrls: ['./data-home.component.scss'],
})
export class DataHomeComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
